export const chartColors: string[] = [
  '#26FF94',  // bright mint green
  '#09FA8B',  // vibrant green
  '#1FC080',  // medium sea green
  '#00C375',  // emerald green
  '#58FFA6',  // light mint green
  '#00d07d',  // medium-dark green
  '#00B66D',  // forest green
  '#007345',  // dark forest green
  '#173706',  // very dark green
  '#071e03'   // almost black green
];

export const chartColors2: string[] = [
  '#6DFF9E',  // light mint
  '#3FBE5E',  // medium green
  '#256F3C',  // forest green
  '#00FF70',  // bright green
  '#2BAE48',  // grass green
  '#3dfa9c',  // aqua green
  '#6dbb8f',  // sage green
  '#36e9b7',  // turquoise
  '#24ff9b',  // bright mint
  '#00ff71'   // vivid green
];
